import moment from "moment";
import { lowerCaseRemoveSpace } from "helpers/utils";
import { ExtendedSymptomData } from "pages/symptoms/SymptomsModal";

export const legSwellingMapper = ({
  filteredExtendedSymptomData,
  mapperType,
  mapperValue
}: {
  filteredExtendedSymptomData?: ExtendedSymptomData[] | null;
  mapperType?: string | undefined;
  mapperValue?: string | number | undefined;
}) => {
  const severity: [string, number, string][] = [];

  const sortedData = filteredExtendedSymptomData?.sort(
    (a, b) => moment(a.timestamp).valueOf() - moment(b.timestamp).valueOf()
  );

  if (mapperType) {
    let tooltipValue = "";
    if (lowerCaseRemoveSpace(mapperType) === "severity") {
      switch (mapperValue) {
        case 1:
          tooltipValue = "Mild up to ankles or shins only";
          break;
        case 5:
          tooltipValue = "Moderate, up to knees";
          break;
        case 10:
          tooltipValue = "Severe, up to thighs";
          break;
      }
    }
    return tooltipValue;
  }

  sortedData?.forEach(item => {
    item.data?.map(item2 => {
      if (lowerCaseRemoveSpace(item2?.key) === "severity") {
        let value = 0;
        switch (lowerCaseRemoveSpace(item2?.value)) {
          case "milduptoanklesorshinsonly":
            value = 1;
            break;
          case "moderate,uptoknees":
            value = 5;
            break;
          case "severe,uptothighs":
            value = 10;
            break;
        }
        severity.push([
          String(moment(item.timestamp).valueOf()),
          value,
          "Severity"
        ]);
      }
    });
  });

  return [severity];
};
